import lazyLoad from '@utils/lazyLoad'
const applicationCode = 'fe215caa-efeb-4646-836a-92cd3904f3d7'

const operationalToolsRoutes = [
  // 权益包
  {
    path: '/members/operationalTools/equities',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/OperationalTools/Equities')
    ),
    meta: {
      layoutMode: 'empty',
      title: '付费权益'
    }
  },
  // 新增权益包
  {
    path: '/members/operationalTools/equities/create/:brandId',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/OperationalTools/Equities/Update')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '新增权益包'
    }
  },
  {
    path: '/members/operationalTools/equities/edit/:brandId/:id/:status',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/OperationalTools/Equities/Update')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '编辑权益包'
    }
  },
  // 权益包详情
  {
    path: '/members/operationalTools/equities/detail/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/OperationalTools/Equities/Detail')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '购买记录'
    }
  },
  // 会员导入
  {
    path: '/members/import/dataImport',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/Import/DataImport/MemberImport')
    )
  },
  // 新建带参码
  {
    path: '/members/operationalTools/withParamsCodeList/create',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/OperationalTools/WithParamsCodeList/Create')
    ),
    meta: {
      title: '新建带参码'
    }
  },
  {
    path: '/members/operationalTools/withParamsCodeList',
    exact: true,
    component: lazyLoad(() =>
      import(
        '@views/Members/OperationalTools/WithParamsCodeList/WithParamsCodeList'
      )
    ),
    meta: {
      title: '带参码',
      layoutMode: 'empty'
    }
  },
  // 带参码明细
  {
    path:
      '/members/operationalTools/withParamsCodeList/withParamsCodeDetail/:id',
    exact: true,
    component: lazyLoad(() =>
      import(
        '@views/Members/OperationalTools/WithParamsCodeList/WithParamsCodeDetail'
      )
    ),
    meta: {
      title: '带参码明细',
      layoutMode: 'empty'
    }
  },
  // 带参码明细的详情
  {
    path: '/members/operationalTools/withParamsCodeList/detail/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/OperationalTools/WithParamsCodeList/Detail')
    ),
    meta: {
      title: '带参码详情',
      layoutMode: 'empty'
    }
  },
  // 储值详情
  {
    path: '/recharge-mangement/recharge-detail',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/RechargeManagement/RechargeDetail/PayRecord')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '储值查询'
    }
  }
]

export default operationalToolsRoutes
